import * as React from 'react';
import { Switch, Redirect } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '@common/hooks';
import { EComponentTypes } from '@common/definitions';
import Route from '../../../../common/components/route';
import { SubNavigationBar } from '../../../../common/components/navigation-bar';
import { OrganisationGeneralSettingsContainer } from '../general-settings';
import ShortcutsContainer from '../shortcuts';
import { OrganisationBrandingSettingsContainer } from '../branding-settings';
import { OrganisationIntegrationSettingsContainer } from '../integration-settings/integration-settings';

const OrganisationSettingsContainer = () => {
  const { t } = useTranslation();
  const hasHome = useAppSelector((state) => state.organisation.selected.enabled_components?.includes(
    EComponentTypes.HOME
  )
  );
  const organisation = useAppSelector((state) => state.organisation.selected);

  return (
    <>
      <Route
        path="/admin/settings"
        component={() => (
          <SubNavigationBar title={t('core:tab_organisation_settings')}>
            <SubNavigationBar.Item
              icon="settings"
              path="/admin/settings/general"
              title={t('organisation:settings_index_general_title')}
            />
            <SubNavigationBar.Item
              icon="format_paint"
              path="/admin/settings/branding"
              title={t('organisation:settings_index_branding_title')}
            />
            <SubNavigationBar.Item
              icon="ios_share"
              path="/admin/settings/shortcuts"
              title={
                hasHome
                  ? t('organisation:settings_index_shortcuts_apps_title')
                  : t('organisation:settings_index_shortcuts_title')
              }
            />
            {organisation.integrations &&
              organisation.integrations.length > 0 && (
                <SubNavigationBar.Item
                  icon="settings__filled"
                  path="/admin/settings/integration"
                  title={t('organisation:settings_index_integration_title')}
                />
            )}
          </SubNavigationBar>
        )}
      />
      <Switch>
        <Route
          path="/admin/settings/general"
          component={OrganisationGeneralSettingsContainer}
        />
        <Route
          path={[
            '/admin/settings/shortcuts/:shortcutId',
            '/admin/settings/shortcuts',
          ]}
          component={ShortcutsContainer}
        />
        <Route
          path="/admin/settings/branding"
          component={OrganisationBrandingSettingsContainer}
        />
        <Route
          path="/admin/settings/integration"
          component={OrganisationIntegrationSettingsContainer}
        />
        <Redirect to="/admin/settings/general" />
      </Switch>
    </>
  );
};

export default OrganisationSettingsContainer;
